import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/1.png'
import _imports_1 from '@/assets/2.png'
import _imports_2 from '@/assets/3.png'
import _imports_3 from '@/assets/4.png'


const _hoisted_1 = { class: "maintenance-form-wrapper" }
const _hoisted_2 = { class: "top-navigation" }
const _hoisted_3 = { class: "nav-left" }
const _hoisted_4 = { class: "nav-right" }
const _hoisted_5 = { class: "el-dropdown-link" }
const _hoisted_6 = { class: "maintenance-form-container" }
const _hoisted_7 = { class: "form-header" }
const _hoisted_8 = { class: "form-title" }
const _hoisted_9 = { class: "welcome-text" }
const _hoisted_10 = { class: "form-section" }
const _hoisted_11 = { class: "field-label" }
const _hoisted_12 = { class: "form-section" }
const _hoisted_13 = { class: "field-label" }
const _hoisted_14 = { class: "form-section" }
const _hoisted_15 = { class: "field-label" }
const _hoisted_16 = { class: "form-section" }
const _hoisted_17 = { class: "field-label" }
const _hoisted_18 = { class: "form-section line-id-section" }
const _hoisted_19 = { class: "field-label" }
const _hoisted_20 = { class: "field-hint" }
const _hoisted_21 = { class: "line-id-content" }
const _hoisted_22 = { class: "form-section" }
const _hoisted_23 = { class: "field-label" }
const _hoisted_24 = { class: "form-section" }
const _hoisted_25 = { class: "field-label" }
const _hoisted_26 = { class: "repair-type-tree" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "category-name" }
const _hoisted_29 = {
  key: 0,
  class: "category-items"
}
const _hoisted_30 = {
  key: 0,
  class: "repair-items-loading"
}
const _hoisted_31 = {
  key: 0,
  class: "repair-item-detail"
}
const _hoisted_32 = {
  key: 2,
  class: "no-repair-items"
}
const _hoisted_33 = { class: "form-section" }
const _hoisted_34 = { class: "field-label" }
const _hoisted_35 = { class: "form-section" }
const _hoisted_36 = { class: "field-label" }
const _hoisted_37 = { class: "form-section" }
const _hoisted_38 = { class: "field-label" }
const _hoisted_39 = { class: "form-section" }
const _hoisted_40 = { class: "field-label" }
const _hoisted_41 = { class: "form-section" }
const _hoisted_42 = { class: "field-label" }
const _hoisted_43 = { class: "field-hint" }
const _hoisted_44 = { class: "image-center" }
const _hoisted_45 = { class: "form-actions" }
const _hoisted_46 = { class: "preview-container" }
const _hoisted_47 = ["src"]
const _hoisted_48 = ["src"]

import { ref, reactive, computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { ElMessage, FormInstance, FormRules, UploadUserFile, UploadProps } from 'element-plus'
import { Plus, ArrowDown, ArrowRight, QuestionFilled, Search, Loading } from '@element-plus/icons-vue'
import axios from 'axios'

interface RepairCategory {
  categoryId: number
  categoryName: string
  sortOrder: number
  status: number
}

interface RepairItem {
  templateId: number
  repairType: string
  itemName: string
  price: string
  remark: string
}

const acceptFileTypes = 'image/jpeg,image/png,image/gif,image/webp,video/mp4,video/quicktime,video/x-msvideo,video/webm'

// Validation rules

export default /*@__PURE__*/_defineComponent({
  __name: 'MaintenanceForm',
  setup(__props) {

const { t, locale } = useI18n()

// Repair type categories and items
const repairCategories = ref<RepairCategory[]>([])
const repairItems = ref<RepairItem[]>([])
const selectedRepairCategory = ref('')
const repairItemsLoading = ref(false)

// Fetch repair categories on mount
onMounted(async () => {
  await fetchRepairCategories()
})

// Fetch all repair categories
const fetchRepairCategories = async () => {
  try {
    const langMap: Record<string, string> = {
      'zh-TW': 'zh_TW',
      'zh-CN': 'zh_CN',
      'en': 'en_US'
    }
    const apiLang = langMap[locale.value] || 'zh_TW'
    
    const response = await axios.get(`/api/repair-price/types?lang=${apiLang}`)
    if (response.data.code === 200) {
      repairCategories.value = response.data.data || []
    }
  } catch (error) {
    console.error('Failed to fetch repair categories:', error)
  }
}

// Fetch repair items by category
const fetchRepairItems = async (repairType: string) => {
  repairItemsLoading.value = true
  try {
    const langMap: Record<string, string> = {
      'zh-TW': 'zh_TW',
      'zh-CN': 'zh_CN',
      'en': 'en_US'
    }
    const apiLang = langMap[locale.value] || 'zh_TW'
    
    const response = await axios.get(`/api/repair-price/by-type?lang=${apiLang}&repairType=${encodeURIComponent(repairType)}`)
    if (response.data.code === 200) {
      repairItems.value = response.data.data || []
    }
  } catch (error) {
    console.error('Failed to fetch repair items:', error)
    repairItems.value = []
  } finally {
    repairItemsLoading.value = false
  }
}

// Handle repair category change
const handleRepairCategoryChange = (categoryName: string) => {
  // Clear previously selected items when category changes
  formData.repairTypes = []
  if (categoryName) {
    fetchRepairItems(categoryName)
  } else {
    repairItems.value = []
  }
}

// Toggle category expansion
const toggleCategory = (categoryName: string) => {
  if (selectedRepairCategory.value === categoryName) {
    // Collapse if already selected
    selectedRepairCategory.value = ''
    repairItems.value = []
  } else {
    // Expand and load items
    selectedRepairCategory.value = categoryName
    formData.repairTypes = []
    fetchRepairItems(categoryName)
  }
}

// Language switcher
const currentLanguageName = computed(() => {
  return t(`language.${locale.value.replace('-', '')}`)
})

const handleLanguageChange = (lang: string) => {
  locale.value = lang
}

// Form reference
const formRef = ref<FormInstance>()

// Form data
const formData = reactive({
  email: '',
  name: '',
  phone: '',
  address: '',
  lineId: '',
  urgentType: '',
  repairTypes: [] as string[],
  description: '',
  images: [] as string[],
  howKnow: '',
  howKnowOther: '',
  referrer: '',
  joinedLine: ''
})

// File list for upload
const fileList = ref<UploadUserFile[]>([])

// Image IDs from upload
const uploadedImageIds = ref<number[]>([])

// Media preview (images and videos)
const dialogVisible = ref(false)
const dialogMediaUrl = ref('')
const isVideoPreview = ref(false)

// Store original video URLs for preview (uid -> url)
const videoOriginalUrls = ref<Record<string, string>>({})

// Accepted file types (images and videos)
const rules = reactive<FormRules>({
  email: [
    { required: true, message: () => t('form.required'), trigger: 'blur' },
    { type: 'email', message: () => t('form.invalidEmail'), trigger: 'blur' }
  ],
  name: [
    { required: true, message: () => t('form.required'), trigger: 'blur' }
  ],
  phone: [
    { required: true, message: () => t('form.required'), trigger: 'blur' },
    { 
      validator: (rule: any, value: string, callback: any) => {
        if (value && !/^\d{10}$/.test(value)) {
          callback(new Error(t('form.invalidPhone')))
        } else {
          callback()
        }
      }, 
      trigger: 'blur' 
    }
  ],
  address: [
    { required: true, message: () => t('form.required'), trigger: 'blur' }
  ],
  lineId: [],
  urgentType: [
    { required: true, message: () => t('form.required'), trigger: 'change' }
  ]
})

// Upload handlers
const handlePictureCardPreview: UploadProps['onPreview'] = (uploadFile) => {
  const fileType = uploadFile.raw?.type || ''
  const isVideo = fileType.startsWith('video/')
  isVideoPreview.value = isVideo
  // Use original video URL for preview, thumbnail URL for images
  if (isVideo && uploadFile.uid && videoOriginalUrls.value[uploadFile.uid]) {
    dialogMediaUrl.value = videoOriginalUrls.value[uploadFile.uid]
  } else {
    dialogMediaUrl.value = uploadFile.url!
  }
  dialogVisible.value = true
}

// Before upload validation
const beforeUpload: UploadProps['beforeUpload'] = (rawFile) => {
  const isImage = rawFile.type.startsWith('image/')
  const isVideo = rawFile.type.startsWith('video/')
  if (!isImage && !isVideo) {
    ElMessage.error(t('form.invalidFileType'))
    return false
  }
  // Limit file size: images 10MB, videos 100MB
  const maxSize = isVideo ? 100 * 1024 * 1024 : 10 * 1024 * 1024
  if (rawFile.size > maxSize) {
    ElMessage.error(isVideo ? t('form.videoTooLarge') : t('form.imageTooLarge'))
    return false
  }
  return true
}

const handleRemove: UploadProps['onRemove'] = (uploadFile, uploadFiles) => {
  // Remove corresponding image ID if exists
  const index = fileList.value.findIndex(f => f.uid === uploadFile.uid)
  if (index !== -1 && uploadedImageIds.value[index]) {
    uploadedImageIds.value.splice(index, 1)
  }
  // Clean up video URL if exists
  if (uploadFile.uid && videoOriginalUrls.value[uploadFile.uid]) {
    URL.revokeObjectURL(videoOriginalUrls.value[uploadFile.uid])
    delete videoOriginalUrls.value[uploadFile.uid]
  }
}

// Generate video thumbnail from first frame
const generateVideoThumbnail = (file: File): Promise<string> => {
  return new Promise((resolve) => {
    const video = document.createElement('video')
    video.preload = 'metadata'
    video.muted = true
    video.playsInline = true
    
    video.onloadeddata = () => {
      video.currentTime = 0.1 // Seek to first frame
    }
    
    video.onseeked = () => {
      const canvas = document.createElement('canvas')
      canvas.width = video.videoWidth
      canvas.height = video.videoHeight
      const ctx = canvas.getContext('2d')
      ctx?.drawImage(video, 0, 0, canvas.width, canvas.height)
      const thumbnail = canvas.toDataURL('image/jpeg', 0.8)
      URL.revokeObjectURL(video.src)
      resolve(thumbnail)
    }
    
    video.onerror = () => {
      URL.revokeObjectURL(video.src)
      resolve('') // Return empty on error
    }
    
    video.src = URL.createObjectURL(file)
  })
}

const handleChange: UploadProps['onChange'] = async (uploadFile, uploadFiles) => {
  // Upload file when added
  if (uploadFile.status === 'ready' && uploadFile.raw) {
    // Generate thumbnail for video files and store original URL
    const isVideo = uploadFile.raw.type.startsWith('video/')
    if (isVideo) {
      // Store original video URL for preview
      const originalUrl = URL.createObjectURL(uploadFile.raw)
      videoOriginalUrls.value[uploadFile.uid] = originalUrl
      
      // Generate thumbnail for display
      const thumbnail = await generateVideoThumbnail(uploadFile.raw)
      if (thumbnail) {
        uploadFile.url = thumbnail
      }
    }
    try {
      const formData = new FormData()
      formData.append('file', uploadFile.raw)
      formData.append('businessType', 'RESERVATION')
      formData.append('businessId', '0')
      formData.append('uploadUserId', '0')
      
      // Get current language for API
      const langMap: Record<string, string> = {
        'zh-TW': 'zh_TW',
        'zh-CN': 'zh_CN',
        'en': 'en_US'
      }
      const apiLang = langMap[locale.value] || 'zh_TW'
      
      const response = await axios.post(
        `/api/image/upload?lang=${apiLang}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Accept-Language': apiLang
          }
        }
      )
      
      if (response.data.code === 200) {
        // Store image/video ID (backend may return imageId, mediaId, or videoId)
        const uploadedId = response.data.data.imageId || response.data.data.mediaId || response.data.data.videoId
        if (uploadedId) {
          uploadedImageIds.value.push(uploadedId)
        }
        ElMessage.success(t('form.uploadSuccess'))
      } else {
        ElMessage.error(response.data.message || t('form.uploadFailed'))
        // Remove failed upload from file list
        const index = fileList.value.findIndex(f => f.uid === uploadFile.uid)
        if (index !== -1) {
          fileList.value.splice(index, 1)
        }
      }
    } catch (error: any) {
      console.error('Upload error:', error)
      const errorMsg = error.response?.data?.message || t('form.uploadFailed')
      ElMessage.error(errorMsg)
      // Remove failed upload from file list
      const index = fileList.value.findIndex(f => f.uid === uploadFile.uid)
      if (index !== -1) {
        fileList.value.splice(index, 1)
      }
    }
  }
}

// Submit form
const submitForm = async () => {
  if (!formRef.value) return

  try {
    const valid = await formRef.value.validate()
    if (valid) {
      // Repair types are now item names from API, join them directly
      const repairTypesText = formData.repairTypes.join(',')

      // Convert source channel code to Chinese text
      const sourceChannelMap: Record<string, string> = {
        'fate': t('form.howKnowOptions.fate'),
        'referral': t('form.howKnowOptions.referral'),
        'line': t('form.howKnowOptions.line'),
        'fb': t('form.howKnowOptions.fb'),
        'ad': t('form.howKnowOptions.ad'),
        'other': t('form.howKnowOptions.other')
      }
      const sourceChannelText = sourceChannelMap[formData.howKnow] || formData.howKnow

      // Map form data to API format
      const submitData = {
        realName: formData.name,
        phone: formData.phone,
        email: formData.email,
        lineId: formData.lineId,
        address: formData.address,
        isUrgent: formData.urgentType === 'urgent' ? 1 : 0,
        repairType: repairTypesText, // 中文修缮类型，逗号分隔
        supplementDesc: formData.description,
        sourceChannel: sourceChannelText, // 中文来源渠道
        recommenderName: formData.referrer,
        isJoin: formData.joinedLine === 'yes' ? 1 : 0,
        imageIds: uploadedImageIds.value.filter(id => id != null), // 上传的图片/视频ID列表，过滤null值
        userId: 0 // 未登录用户
      }

      // Get current language for API
      const langMap: Record<string, string> = {
        'zh-TW': 'zh_TW',
        'zh-CN': 'zh_CN',
        'en': 'en_US'
      }
      const apiLang = langMap[locale.value] || 'zh_TW'

      // Submit to API with language parameter
      const response = await axios.post(
        `/api/reservation/create?lang=${apiLang}`,
        submitData,
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': apiLang
          }
        }
      )
      
      if (response.data.code === 200) {
        // Success - redirect to success page with reservation data
        const reservationData = {
          reservationId: response.data.data.reservationId,
          phone: response.data.data.phone,
          createTime: response.data.data.createTime
        }
        const dataStr = encodeURIComponent(JSON.stringify(reservationData))
        window.location.href = `/#/success/${dataStr}`
      } else {
        ElMessage.error(response.data.message || t('form.submitFailed'))
      }
    }
  } catch (error: any) {
    console.error('Submit error:', error)
    const errorMsg = error.response?.data?.message || '提交失敗，請稍後再試'
    ElMessage.error(errorMsg)
  }
}

// Reset form
const resetForm = () => {
  formRef.value?.resetFields()
  fileList.value = []
  uploadedImageIds.value = []
}

// Navigate to my reservations
const goToMyReservations = () => {
  window.location.href = '/#/my-reservations'
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          text: "",
          onClick: goToMyReservations
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Search))
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_unref(t)('navigation.myReservations')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_dropdown, { onCommand: handleLanguageChange }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, { command: "zh-TW" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('language.zhTW')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, { command: "zh-CN" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('language.zhCN')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_5, [
              _createTextVNode(_toDisplayString(currentLanguageName.value) + " ", 1),
              _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ArrowDown))
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h1", _hoisted_8, _toDisplayString(_unref(t)('form.title')), 1),
        _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)('form.welcome')), 1)
      ]),
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: formData,
        rules: rules,
        "label-position": "top",
        class: "maintenance-form"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_form_item, { prop: "email" }, {
              label: _withCtx(() => [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('form.email')), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.email,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.email) = $event)),
                  placeholder: _unref(t)('form.emailPlaceholder')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_el_form_item, { prop: "name" }, {
              label: _withCtx(() => [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('form.name')), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.name) = $event)),
                  placeholder: _unref(t)('form.namePlaceholder')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_el_form_item, { prop: "phone" }, {
              label: _withCtx(() => [
                _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)('form.phone')), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.phone,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.phone) = $event)),
                  placeholder: _unref(t)('form.phonePlaceholder')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_el_form_item, { prop: "address" }, {
              label: _withCtx(() => [
                _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)('form.address')), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.address,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.address) = $event)),
                  placeholder: _unref(t)('form.addressPlaceholder')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_el_form_item, { prop: "lineId" }, {
              label: _withCtx(() => [
                _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(t)('form.lineId')), 1),
                _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(t)('form.lineIdHint')), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_21, [
                  _cache[14] || (_cache[14] = _createElementVNode("div", { class: "image-center" }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: "Line ID 設定",
                      class: "line-id-image"
                    })
                  ], -1)),
                  _createVNode(_component_el_input, {
                    modelValue: formData.lineId,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.lineId) = $event)),
                    placeholder: _unref(t)('form.lineIdPlaceholder'),
                    class: "line-id-input"
                  }, null, 8, ["modelValue", "placeholder"])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_el_form_item, { prop: "urgentType" }, {
              label: _withCtx(() => [
                _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(t)('form.isUrgent')), 1)
              ]),
              default: _withCtx(() => [
                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "pricing-info image-center" }, [
                  _createElementVNode("img", {
                    src: _imports_1,
                    alt: "場勘報價服務",
                    class: "pricing-image"
                  })
                ], -1)),
                _createVNode(_component_el_radio_group, {
                  modelValue: formData.urgentType,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.urgentType) = $event)),
                  class: "radio-group-vertical"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: "general" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('form.urgentGeneral')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "urgent" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('form.urgentEmergency')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_el_form_item, { prop: "repairType" }, {
              label: _withCtx(() => [
                _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(t)('form.repairType')), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(repairCategories.value, (category) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: category.categoryId,
                      class: "repair-category-node"
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["category-header", { active: selectedRepairCategory.value === category.categoryName }]),
                        onClick: ($event: any) => (toggleCategory(category.categoryName))
                      }, [
                        _createVNode(_component_el_icon, { class: "expand-icon" }, {
                          default: _withCtx(() => [
                            (selectedRepairCategory.value !== category.categoryName)
                              ? (_openBlock(), _createBlock(_unref(ArrowRight), { key: 0 }))
                              : (_openBlock(), _createBlock(_unref(ArrowDown), { key: 1 }))
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("span", _hoisted_28, _toDisplayString(category.categoryName), 1)
                      ], 10, _hoisted_27),
                      (selectedRepairCategory.value === category.categoryName)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            (repairItemsLoading.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                  _createVNode(_component_el_icon, { class: "is-loading" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Loading))
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : (repairItems.value.length > 0)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(repairItems.value, (item) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: item.templateId,
                                      class: "repair-item-node"
                                    }, [
                                      _createVNode(_component_el_checkbox, {
                                        modelValue: formData.repairTypes,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.repairTypes) = $event)),
                                        label: item.itemName
                                      }, null, 8, ["modelValue", "label"]),
                                      (formData.repairTypes.includes(item.itemName))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                                            _createTextVNode(_toDisplayString(item.price), 1),
                                            (item.remark)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode(" · " + _toDisplayString(item.remark), 1)
                                                ], 64))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                : (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_unref(t)('form.noRepairItems')), 1))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_el_form_item, { prop: "description" }, {
              label: _withCtx(() => [
                _createElementVNode("span", _hoisted_34, _toDisplayString(_unref(t)('form.description')), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.description,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.description) = $event)),
                  type: "textarea",
                  rows: 3,
                  placeholder: _unref(t)('form.descriptionPlaceholder')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createVNode(_component_el_form_item, { prop: "images" }, {
              label: _withCtx(() => [
                _createElementVNode("span", _hoisted_36, _toDisplayString(_unref(t)('form.images')), 1)
              ]),
              default: _withCtx(() => [
                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "upload-guide image-center" }, [
                  _createElementVNode("img", {
                    src: _imports_2,
                    alt: "拍攝參考",
                    class: "guide-image"
                  })
                ], -1)),
                _createVNode(_component_el_upload, {
                  "file-list": fileList.value,
                  "onUpdate:fileList": _cache[8] || (_cache[8] = ($event: any) => ((fileList).value = $event)),
                  action: "#",
                  "list-type": "picture-card",
                  "auto-upload": false,
                  limit: 9,
                  accept: acceptFileTypes,
                  "on-preview": handlePictureCardPreview,
                  "on-remove": handleRemove,
                  "on-change": handleChange,
                  "before-upload": beforeUpload,
                  class: "image-uploader"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Plus))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["file-list"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_el_form_item, { prop: "howKnow" }, {
              label: _withCtx(() => [
                _createElementVNode("span", _hoisted_38, _toDisplayString(_unref(t)('form.howKnow')), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: formData.howKnow,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.howKnow) = $event)),
                  class: "radio-group-vertical"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: "fate" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('form.howKnowOptions.fate')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "referral" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('form.howKnowOptions.referral')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "line" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('form.howKnowOptions.line')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "fb" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('form.howKnowOptions.fb')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "ad" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('form.howKnowOptions.ad')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "other" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('form.howKnowOptions.other')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (formData.howKnow === 'other')
                  ? (_openBlock(), _createBlock(_component_el_input, {
                      key: 0,
                      modelValue: formData.howKnowOther,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.howKnowOther) = $event)),
                      placeholder: _unref(t)('form.otherPlaceholder'),
                      style: {"margin-top":"12px"}
                    }, null, 8, ["modelValue", "placeholder"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_el_form_item, { prop: "referrer" }, {
              label: _withCtx(() => [
                _createElementVNode("span", _hoisted_40, _toDisplayString(_unref(t)('form.referrer')), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.referrer,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.referrer) = $event)),
                  placeholder: _unref(t)('form.referrerPlaceholder')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createVNode(_component_el_form_item, { prop: "joinedLine" }, {
              label: _withCtx(() => [
                _createElementVNode("span", _hoisted_42, _toDisplayString(_unref(t)('form.joinedLine')), 1),
                _createElementVNode("p", _hoisted_43, [
                  _createTextVNode(_toDisplayString(_unref(t)('form.joinedLineHint')), 1),
                  _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_unref(t)('form.lineAccount')) + " ", 1),
                  _cache[18] || (_cache[18] = _createElementVNode("a", {
                    href: "https://lin.ee/4093KX5",
                    target: "_blank",
                    class: "line-link"
                  }, "https://lin.ee/4093KX5", -1))
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_44, [
                  _cache[19] || (_cache[19] = _createElementVNode("div", { class: "qr-code-container" }, [
                    _createElementVNode("img", {
                      src: _imports_3,
                      alt: "LINE QR Code",
                      class: "qr-code-image"
                    })
                  ], -1)),
                  _createVNode(_component_el_radio_group, {
                    modelValue: formData.joinedLine,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.joinedLine) = $event)),
                    class: "radio-group-vertical",
                    style: {"margin-top":"16px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, { label: "yes" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('form.yes')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, { label: "no" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('form.no')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: submitForm
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('form.submit')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, { onClick: resetForm }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('form.clear')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((dialogVisible).value = $event)),
      title: isVideoPreview.value ? _unref(t)('form.videoPreview') : _unref(t)('form.imagePreview'),
      width: "80%",
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_46, [
          (isVideoPreview.value)
            ? (_openBlock(), _createElementBlock("video", {
                key: 0,
                src: dialogMediaUrl.value,
                controls: "",
                class: "preview-video"
              }, null, 8, _hoisted_47))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: dialogMediaUrl.value,
                alt: "Preview",
                class: "preview-image"
              }, null, 8, _hoisted_48))
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})